import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useDispatch } from 'react-redux';

import { changeFormByIndex, deleteItemForm } from '../actions/forms';
import { TICKET_CODES_FORM } from '../reducers/features';

const AddTicketItem = ({ index, ticket, countTickets }) => {
    const dispatch = useDispatch();
    return (
        <div className="add-tickets__item border rounded p-3 mb-3">
            <div className="add-tickets__title mb-2 d-flex justify-content-between">
                <h6 className="fw-bold"><FormattedMessage id="ticket"/> #{index + 1}</h6>
                {countTickets > 1 && (<span className="delete_ticket" onClick={() => dispatch(deleteItemForm(TICKET_CODES_FORM, index))}>
                    <i className="bi bi-trash"/>
                </span>)}
            </div>
            <div className="add-tickets__text mb-2">
                <FormattedMessage id="add_code_printed_ticket"/>
            </div>
            <FloatingLabel
                controlId="add-ticket-code"
                label={<FormattedMessage id="enter_ticket_code"/>} className={ticket.errorMessage && 'text-success'}>
                <Form.Control size="lg" label="add-ticket-code" type="text" placeholder={<FormattedMessage id="enter_ticket_code"/>}
                    isInvalid={ticket.isValid === false}
                    isValid={ticket.isValid === true}
                    value={ticket.code}
                    onChange={(e) => dispatch(changeFormByIndex(
                        TICKET_CODES_FORM,
                        index,
                        {
                            code: e.target.value,
                            isValid: null,
                            errorMessage: null,
                        },
                    ))}
                />
                {ticket.errorMessage && <span className='text-danger'>{ticket.errorMessage}</span>}
            </FloatingLabel>
        </div>
    );
};

export default AddTicketItem;
